'use client';

import { useEffect } from 'react';

/**
 * OAuth回调处理组件
 * 用于处理从OAuth提供商重定向回来的新窗口
 * 检测localStorage中的标识，通过postMessage通知主窗口调用session接口
 */
export function OAuthCallbackHandler() {
  useEffect(() => {
    // 只在客户端执行
    if (typeof window === 'undefined') return;

    // 检查是否是OAuth回调窗口（通过localStorage标识判断）
    const needAuthSession = localStorage.getItem('needAuthSession') === 'true';

    if (needAuthSession) {
      // 清除标识
      localStorage.removeItem('needAuthSession');

      // 通知主窗口调用session接口
      if (window.opener) {
        // 新窗口通知主窗口
        window.opener.postMessage({ type: 'AUTH_SESSION_READY' }, window.location.origin);
        // 延迟关闭，确保消息已发送
        setTimeout(() => {
          window.close();
        }, 100);
      } else {
        // 如果是主窗口，直接触发session获取
        window.postMessage({ type: 'AUTH_SESSION_READY' }, window.location.origin);
      }
    }
  }, []);

  return null;
}
